// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_MQI6k {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--_00000020-background);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}


.setPaymentModalBg_VGZKR {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: var(--white-background);
  min-height: 458px;
  min-width: 352px;
  max-width: 352px;
}
.stripeButton_ExYsl {
  padding: 14px;
  width: 100%;
  background: var(--_16c098-color);
  color: var(--white-color);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 20px;
  transition: background 0.2s;
}

.message_oBhtJ {
  margin-top: 10px;
  color: red;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/AccountSettings/StripeComponents/Payment.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: var(--_00000020-background);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n\n.setPaymentModalBg {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: var(--white-background);\n  min-height: 458px;\n  min-width: 352px;\n  max-width: 352px;\n}\n.stripeButton {\n  padding: 14px;\n  width: 100%;\n  background: var(--_16c098-color);\n  color: var(--white-color);\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background 0.2s;\n}\n\n.message {\n  margin-top: 10px;\n  color: red;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_MQI6k`,
	"setPaymentModalBg": `setPaymentModalBg_VGZKR`,
	"stripeButton": `stripeButton_ExYsl`,
	"message": `message_oBhtJ`
};
export default ___CSS_LOADER_EXPORT___;
